var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticStyle:{"display":"flex","flex-wrap":"wrap"},attrs:{"fluid":""}},[_c('v-row',{staticStyle:{"padding-top":"150px"}},[_c('v-spacer'),_c('v-col',[_c('v-card',[_c('v-card-text',[_vm._v("Please wait while you are logged out...")])],1)],1),_c('v-spacer')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }